import React, { useEffect, useState } from "react";

// components
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";



export default function DeleteConfirm({showDelete,handleCloseDelete, handleConfirmDelete}) {

  const handleClose = () => {
    handleCloseDelete();
  }
  const handleConfirm = () => {
    handleConfirmDelete();
  }

  return (
    <>
      <Modal isOpen={showDelete} size="md">
        <ModalHeader>Deletar registro?</ModalHeader>
        <ModalBody>
          Ao clicar em confirmar o registro será deletado!
        </ModalBody>
        <ModalFooter>
          <Button color="default" onClick={handleClose}> Cancelar</Button>
          <Button color="danger" onClick={handleConfirm}> Confirmar</Button>
        </ModalFooter>
      </Modal>
    </>

  )
}